module.exports = __webpack_public_path__ + "img/cobrapoint.c7de3550.png";